<template>

    <div id="specialty">
        <b-container>
            <b-row container class="d-flex justify-content-center align-items-center">
                <b-col cols="12" lg="4" class="mb-5">
                    <article>
                        <h3 style="font-weight: bold;">Especialistas em Transporte</h3>
                        <p>Oferecemos serviços completos de transporte
                            para nossos parceiros sempre com soluções
                            inovadoras para lidar com desafios
                            logísticos complexos.
                        </p>
                        <b-btn class="btn-standard" @click="() => handleNavClick('contacts')">Entre em contato</b-btn>
                    </article>
                </b-col>
                <b-col cols="12" lg="8">
                    <SpecialtyCards />
                </b-col>
            </b-row>
        </b-container>
    </div>

</template>

<script>
import { scrollToSection } from '@/services/utils';
import SpecialtyCards from '../users/SpecialtyCards.vue';

    export default {
        components: {SpecialtyCards},

        methods: {
            handleNavClick(id) {
                scrollToSection(id);
                this.selectedNavItem = id;
            }
        },
    }

</script>

<style scoped lang="scss">

#specialty {
    background-image: url("../../assets/page/specialty/background.png");
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.5rem;
}

@media screen and (max-width: 991px){
    #specialty {

        article {
            padding-left: 2rem !important;
        }
    }
}

@media screen and (max-width: 767px){
    #specialty {
        text-align: center;
        article {
            padding-left: 0 !important;
        }
    }
}

</style>